import { BookOpen } from "lucide-react";
import type { FpMessagePart } from "../../../../../schemas/codegen";
import { ExpandableMessageCard, SimpleMessageCard } from "./shared";

interface LookUpKnowledgeProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
}

export function LookUpKnowledge({ part }: LookUpKnowledgeProps) {
  const tags: string[] =
    (Array.isArray(part.args?.tags) ? part.args?.tags : []) || [];

  const displayName =
    part.status === "pending"
      ? "Looking Up Knowledge"
      : part.status === "complete"
        ? "Knowledge Retrieved"
        : "Failed to Retrieve Knowledge";

  // If no tags, show simple card
  if (tags.length === 0) {
    return (
      <SimpleMessageCard
        icon={BookOpen}
        status={part.status}
        title={displayName}
        className="min-w-0"
      />
    );
  }

  // If tags exist, show expandable card
  return (
    <ExpandableMessageCard
      icon={BookOpen}
      status={part.status}
      result={part.result}
      title={displayName}
      className="min-w-0"
      accordionValue="lookup-knowledge"
      expanded={false}
    >
      <div className="space-y-2">
        <div className="text-sm text-muted-foreground">Searched for:</div>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <code
              key={tag}
              className="font-mono text-xs bg-muted px-2 py-1 rounded text-foreground"
            >
              {tag}
            </code>
          ))}
        </div>
      </div>
    </ExpandableMessageCard>
  );
}
